import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Tabs, Tab } from '@mui/material'
import { useOutletContext, useSearchParams } from 'react-router-dom'

import AlertSummary from './AlertSummary/AlertSummary'
import SitePlan from './SitePlan/SitePlan'
import ConfinedSpaceDashboard from './ConfinedSpace/ConfinedSpaceDashboard'

const Dashboard = () => {
  const { t } = useTranslation()
  const { projectInfo } = useOutletContext()
  const [searchParams, setSearchParams] = useSearchParams()

  const [currentTab, setCurrentTab] = useState(searchParams.get('tab') ?? "alert")

  const switchTab = (value) => {
    setCurrentTab(value)
    setSearchParams({ tab: value })
  }

  return (<>
    <div className="mainContainer">
      <Tabs value={currentTab} onChange={(_, value) => switchTab(value)} style={{ marginBottom: "10px" }}>
        <Tab label="Alert Summary" value="alert"/>

        <Tab label="Site Plan" value="site_plan"/>

        {(projectInfo["modules"] .filter((i) => i["module"] === "confined_space")[0]["enabled"] === true) &&
          <Tab label={t("module_confinedSpace")} value="confined_space"/>
        }
      </Tabs>

      {currentTab === "alert" && 
        <Box style={{ flexGrow: 1, overflow: "auto" }}>
          <AlertSummary projectInfo={projectInfo}/>
        </Box>
      }

      {currentTab === "site_plan" && 
        <Box style={{ flexGrow: 1, overflow: "auto" }}>
          <SitePlan projectInfo={projectInfo}/>
        </Box>
      }

      {currentTab === "confined_space" && 
        <Box style={{ flexGrow: 1, overflow: "auto" }}>
          <ConfinedSpaceDashboard projectInfo={projectInfo}/>
        </Box>
      }
    </div>
  </>)
}

export default Dashboard
